/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Unknown_CompanyInputs */

const en_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const de_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const fr_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const es_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const it_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuta`)
};

const nl_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekend`)
};

const pl_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznana`)
};

const fi_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon`)
};

const da_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt`)
};

const sv_applications_unknown_company = /** @type {(inputs: Applications_Unknown_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänt`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Applications_Unknown_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_unknown_company = /** @type {((inputs?: Applications_Unknown_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Unknown_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_unknown_company(inputs)
	if (locale === "fr") return fr_applications_unknown_company(inputs)
	if (locale === "es") return es_applications_unknown_company(inputs)
	if (locale === "it") return it_applications_unknown_company(inputs)
	if (locale === "nl") return nl_applications_unknown_company(inputs)
	if (locale === "pl") return pl_applications_unknown_company(inputs)
	if (locale === "fi") return fi_applications_unknown_company(inputs)
	if (locale === "da") return da_applications_unknown_company(inputs)
	if (locale === "sv") return sv_applications_unknown_company(inputs)
	return en_applications_unknown_company(inputs)
});